(function () {
  var P = "mt_sp_pref",
    g = "mt_sp_opt_out",
    b = "shipping-protection",
    h = !1,
    l = null,
    a = null,
    c = null,
    E = 0,
    T = !1,
    n = w();
  (a = n), y(!n), n || d(!1);
  function k(t) {
    try {
      var e = window.localStorage.getItem(t);
      if (e != null) return e;
    } catch {}
    try {
      return window.sessionStorage.getItem(t);
    } catch {
      return null;
    }
  }
  function O(t, e) {
    try {
      window.localStorage.setItem(t, e);
    } catch {}
    try {
      window.sessionStorage.setItem(t, e);
    } catch {}
  }
  function j(t) {
    try {
      window.localStorage.removeItem(t);
    } catch {}
    try {
      window.sessionStorage.removeItem(t);
    } catch {}
  }
  function w() {
    var t = k(P);
    return t === "off" ? !1 : t === "on" ? !0 : k(g) !== "1";
  }
  function y(t) {
    try {
      document.documentElement.classList.toggle("mt-sp-opt-out", !!t);
    } catch {}
  }
  function S(t) {
    (n = !!t), (a = n), O(P, n ? "on" : "off"), n ? j(g) : O(g, "1"), y(!n);
    try {
      window.customerDisabledSP = !n;
    } catch {}
  }
  function N() {
    var t = {};
    return (
      document
        .querySelectorAll(
          "[data-shipping-id], [data-shipping-ids], .protection_switcher[data-variant]",
        )
        .forEach(function (e) {
          var r =
            e.getAttribute("data-shipping-ids") ||
            e.getAttribute("data-shipping-id") ||
            e.getAttribute("data-variant") ||
            "";
          String(r)
            .split(",")
            .forEach(function (o) {
              var i = String(o).trim();
              i && (t[i] = !0);
            });
        }),
      Object.keys(t).length,
      t
    );
  }
  function D() {
    var t = document.querySelector("cart-drawer[data-shipping-id]"),
      e = t ? String(t.getAttribute("data-shipping-id") || "").trim() : "";
    return e;
  }
  function M() {
    var t = document.querySelector(".shipping_protection_box[data-sp-price]");
    if (t && t.getAttribute("data-shipping-id"))
      return t.getAttribute("data-shipping-id");
    var e = document.querySelector(".protection_switcher[data-variant]");
    return e && e.getAttribute("data-variant")
      ? e.getAttribute("data-variant")
      : D();
  }
  function R() {
    var t = document.querySelector(".shipping_protection_box[data-sp-price]");
    if (t) {
      var e = parseInt(t.getAttribute("data-sp-price"), 10);
      if (!isNaN(e) && e > 0) return e;
    }
    return 199;
  }
  function I(t) {
    if (!t) return !1;
    var e = N(),
      r = String(t.variant_id || t.id || "");
    if (e[r]) return !0;
    var o = String(t.handle || "").toLowerCase();
    if (o === b) return !0;
    var i = String(t.url || "").toLowerCase();
    if (i.indexOf("/products/" + b) !== -1) return !0;
    var u = String(t.product_title || t.title || "").toLowerCase();
    return u.indexOf("shipping protection") !== -1;
  }
  function f(t) {
    return !t || !t.items
      ? []
      : t.items.filter(function (e) {
          return I(e) && e.quantity > 0;
        });
  }
  function _(t) {
    return (t.items || []).filter(function (e) {
      return !I(e);
    });
  }
  function s() {
    return fetch("/cart.js", { cache: "no-store" })
      .then(function (t) {
        return t.json();
      })
      .then(function (t) {
        return (c = t), t;
      });
  }
  function F(t, e) {
    return fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: t, quantity: e }),
    }).then(function (r) {
      if (!r.ok) throw new Error("SP cart change failed");
      return r.json();
    });
  }
  function J() {
    var t = M();
    return t
      ? fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ items: [{ id: Number(t), quantity: 1 }] }),
        }).then(function (e) {
          if (!e.ok) throw new Error("SP cart add failed");
          return e.json();
        })
      : Promise.reject(new Error("SP variant id unavailable"));
  }
  function q(t) {
    var e = f(t);
    if (!e.length) return Promise.resolve(t);
    var r = {};
    return (
      e.forEach(function (o) {
        o.key && (r[o.key] = 0);
        var i = String(o.variant_id || o.id || "");
        i && (r[i] = 0);
      }),
      Object.keys(r).length
        ? fetch("/cart/update.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ updates: r }),
          }).then(function (o) {
            if (!o.ok) throw new Error("SP cart remove failed");
            return o.json();
          })
        : Promise.resolve(t)
    );
  }
  function A(t) {
    if (!t) return !1;
    var e = f(t).length > 0;
    return _(t).length === 0 ? !e : n ? e : !e;
  }
  function L(t) {
    return _(t).length === 0
      ? f(t).length
        ? q(t).then(s)
        : Promise.resolve(t)
      : n && !f(t).length
        ? J().then(s).then(V)
        : !n && f(t).length
          ? q(t).then(s)
          : Promise.resolve(t);
  }
  function m() {
    return (
      (n = w()),
      (a = n),
      s()
        .then(L)
        .then(function (t) {
          return A(t) ? t : s().then(L);
        })
    );
  }
  function d(t) {
    document.querySelectorAll(".protection_switcher").forEach(function (e) {
      e.classList.toggle("active", !!t),
        e.setAttribute("aria-checked", t ? "true" : "false");
    });
  }
  function U(t) {
    if (!t) return 0;
    var e = String(t).match(/-?\$?\d[\d,]*(?:\.\d{1,2})?/g);
    if (!e || !e.length) return 0;
    var r = e[e.length - 1].replace(/[^\d.]/g, ""),
      o = parseFloat(r);
    return isNaN(o) ? 0 : Math.round(o * 100);
  }
  function $() {
    if (
      typeof window.afterpay_cart_total_price == "number" &&
      window.afterpay_cart_total_price > 0
    )
      return window.afterpay_cart_total_price;
    var t = document.querySelector(
      "#CartDrawer .totals__total-value, .cart-drawer__footer .totals__total-value, [bss-b2b-cart-total-price], .cart--totalsss",
    );
    return t ? U(t.textContent) : 0;
  }
  function K(t) {
    t < 0 && (t = 0);
    var e;
    typeof Shopify < "u" && typeof Shopify.formatMoney == "function"
      ? (e = Shopify.formatMoney(
          t,
          window.mtCartMoneyFormat ||
            Shopify.money_with_currency_format ||
            Shopify.money_format,
        ))
      : (e = new Intl.NumberFormat(void 0, {
          style: "currency",
          currency: window.mtCartCurrencyCode || "AUD",
        }).format(t / 100)),
      document
        .querySelectorAll(
          "#CartDrawer .totals__total-value, .cart-drawer__footer .totals__total-value, #main-cart-footer .totals__total-value, [bss-b2b-cart-total-price], .cart--totalsss",
        )
        .forEach(function (r) {
          r.textContent = e;
        }),
      (window.afterpay_cart_total_price = t);
  }
  function Q(t, e) {
    var r = R(),
      o = $();
    if (
      (!o &&
        e &&
        typeof window.mtComputeCartDisplayTotal == "function" &&
        (o = window.mtComputeCartDisplayTotal(e)),
      !!o)
    ) {
      var i = e ? f(e).length > 0 : !1,
        u = o;
      t && !i
        ? (u = o + r)
        : !t && i
          ? (u = Math.max(0, o - r))
          : ((t && i) || (!t && !i)) && (u = o),
        K(u),
        typeof window.mtLockEstimatedTotal == "function" &&
          window.mtLockEstimatedTotal(u, null);
    }
  }
  function C(t) {
    if (t && ((c = t), d(n), typeof window.mtSyncCartTotals == "function")) {
      var e =
        typeof window.mtNextCartReq == "function"
          ? window.mtNextCartReq()
          : Date.now();
      window.mtSyncCartTotals(t, null, e);
    }
  }
  function V(t) {
    var e = f(t);
    if (e.length <= 1) return Promise.resolve(t);
    var r = Promise.resolve(t);
    return (
      e.slice(1).forEach(function (o) {
        r = r.then(function () {
          return F(o.key, 0);
        });
      }),
      r.then(s)
    );
  }
  function p() {
    if (l) return l;
    var t = a;
    return (
      (h = !0),
      (l = m()
        .then(function (e) {
          return C(e), e;
        })
        .catch(function (e) {
          return (
            console.error(e),
            s()
              .then(C)
              .catch(function () {})
          );
        })
        .then(function () {
          if (((h = !1), (l = null), a !== t)) return p();
        })),
      l
    );
  }
  function Y(t) {
    if (typeof t == "boolean") {
      var e = Date.now();
      if (!(e - E < 400)) {
        if (
          ((E = e),
          S(t),
          d(t),
          c && typeof window.mtSyncCartTotals == "function")
        ) {
          var r =
            typeof window.mtNextCartReq == "function"
              ? window.mtNextCartReq()
              : Date.now();
          window.mtSyncCartTotals(c, null, r);
        } else Q(t, c);
        p();
      }
    }
  }
  function G(t) {
    var e = t.target;
    return (
      e && e.nodeType !== 1 && (e = e.parentElement),
      !e || !e.closest
        ? !1
        : !!e.closest(".protection_switcher, .protection_switcher_box")
    );
  }
  function x(t) {
    (t.type === "pointerdown" && t.button !== 0) ||
      (G(t) && (t.preventDefault(), t.stopImmediatePropagation(), Y(!n)));
  }
  document.addEventListener("pointerdown", x, !0),
    document.addEventListener("click", x, !0),
    document.addEventListener("DOMContentLoaded", function () {
      (n = w()), (a = n), y(!n), d(n), p();
    }),
    document.addEventListener("cart:updated", function (t) {
      if (!T && !h && !(t.detail && t.detail.source === "sp-enforcement")) {
        var e = t.detail && t.detail.cart;
        e && (c = e), (a = n), d(n), !(e && _(e).length === 0) && p();
      }
    }),
    (window.mtShippingProtection = {
      setPrefOn: S,
      isPrefOn: function () {
        return n;
      },
      applyCartToUI: C,
    }),
    (window.mtSpIsOn = function () {
      return n;
    }),
    (window.mtSyncSPSwitcher = function (t) {
      t && t.items && (c = t), (n = w()), (a = n), d(n), h || p();
    });
  (window.mtEnforceShippingProtection = function (t) {
    return S(t !== "remove"), d(n), p();
  }),
    (window.mtEnsureShippingProtectionCart = m),
    (window.mtPrepareCartCheckout = async function () {
      var cart = await Promise.resolve(l).then(m);
      return { cart: cart };
    }),
    (window.moroccantanRunCheckout = window.moroccantanRunCheckout || function () {
      window.mtCartCheckout.run({ prepare: window.mtPrepareCartCheckout });
    });
  if (window.__mtCartCheckoutQueued && window.mtCartCheckout) {
    window.__mtCartCheckoutQueued = null;
    window.mtCartCheckout.run({ prepare: window.mtPrepareCartCheckout });
  }
})();
